import * as RouteHelper from "@utils/routes";
import { PageBreadcrumbs } from "@stories/atoms/PageBreadcrumbs/PageBreadcrumbs";
import { useProjectContext } from "@hooks/context/useProjectContext";
import { useProfileContext } from "@hooks/context/useProfileContext";
import { StyledCard } from "@stories/atoms/StyledCard/StyledCard";
import { Grid } from "@mui/material";

export const Policies = () => {
  const { userProfile, userOrganisation } = useProfileContext();

  if (!userOrganisation) {
    throw Error("No user organisation");
  }

  const { selectedProject, selectedProjectOrganisation } = useProjectContext();

  const breadcrumbs = [
    {
      path: RouteHelper.contractorDashboard(selectedProject.id),
      name: `${selectedProject.projectName} Policies`,
    },
  ];

  return (
    <>
      <PageBreadcrumbs
        title={`${selectedProject.projectName} Policies`}
        organisationLogo={selectedProjectOrganisation.organisationLogo}
        links={breadcrumbs}
      />

      <StyledCard>
        <Grid container spacing={2} sx={{ padding: "20px" }}></Grid>
      </StyledCard>
    </>
  );
};
